import { Component, Input, OnInit } from '@angular/core';


@Component({
  selector: 'app-open-x-adunit',
  templateUrl: './open-x-adunit.component.html',
  styleUrls: ['./open-x-adunit.component.scss']
})
export class OpenXAdunitComponent implements OnInit {
  @Input() adUnitId: string;
  @Input() width: number;
  @Input() height: number;
  @Input() position: number;
  @Input() ident: string;


  /* GTP ads, see: https://www.npmjs.com/package/ngx-dfp and https://stackblitz.com/edit/angular-fftqvj?file=src%2Fapp%2Fapp.module.ts */
  constructor() { }

  ngOnInit() { }

  private getRandomInt( max ) {
    return Math.floor(Math.random() * Math.floor(max));
  }
}
